import script from "./MobileReviewSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileReviewSheet.vue?vue&type=script&setup=true&lang=ts"

import "./MobileReviewSheet.vue?vue&type=style&index=0&id=2d934222&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d934222"]])

export default __exports__